import {
  IconButton,
  styled,
  Container as BaseContainer,
} from "@material-ui/core";
import {
  AddCircleOutline,
  PlaceOutlined,
  CalendarToday,
  ChevronRight,
} from "@material-ui/icons";
import FullPageCircularProgress from "components/full-page-circular-progress";
import { brand } from "../../theme";

export const Container = styled((p) => <div {...p} />)({
  minHeight: "100vh",
  background: brand.surface,
});

export const InnerContainer = styled((p) => (
  <BaseContainer {...p} disableGutters />
))({
  paddingTop: 8,
  paddingBottom: 16,
});

export const AddButton = styled((p) => (
  <IconButton color="inherit" {...p}>
    <AddCircleOutline />
  </IconButton>
))({});

export const CircularProgress = FullPageCircularProgress;

export const EventList = styled((p) => <div {...p} />)({
  display: "flex",
  flexDirection: "column",
});

export const EventListSectionHeader = styled((p) => <div {...p} />)({
  padding: "14px 20px 5px",
  fontSize: 11,
  fontWeight: 700,
  color: brand.textSec,
  letterSpacing: 1,
  textTransform: "uppercase",
});

export const EventListItem = styled(({ ...p }) => (
  <div role="button" tabIndex={0} {...p} />
))({
  margin: "0 12px 8px",
  borderRadius: 12,
  background: brand.white,
  padding: "14px 16px",
  cursor: "pointer",
  boxShadow: "0 1px 4px rgba(26,18,5,0.06)",
  display: "flex",
  alignItems: "center",
  gap: 12,
  outline: "none",
  "&:focus-visible": {
    boxShadow: `0 0 0 2px ${brand.amber}, 0 1px 4px rgba(26,18,5,0.06)`,
  },
});

export type EventListItemDetailsProps = {
  name?: string;
  venue?: string;
  date?: string;
  [key: string]: any;
};

export const EventListItemDetails = styled(
  ({ name, venue, date, ...p }: EventListItemDetailsProps) => (
    <div {...p}>
      <div className="name">{name}</div>
      <div className="meta">
        <span className="venue">
          <PlaceOutlined fontSize="inherit" />
          {venue}
        </span>
        {date && (
          <span className="date">
            <CalendarToday fontSize="inherit" />
            {date}
          </span>
        )}
      </div>
    </div>
  ),
)({
  flex: 1,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  gap: 6,
  "& .name": {
    fontSize: 15,
    fontWeight: 700,
    color: brand.text,
    lineHeight: 1.2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  "& .meta": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
  },
  "& .venue": {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    color: brand.amberDeep,
    fontSize: 13,
    fontWeight: 600,
  },
  "& .date": {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    color: brand.textSec,
    fontSize: 12,
  },
  "& .MuiSvgIcon-root": {
    fontSize: 14,
  },
});

export const EventListChevron = styled((p) => <ChevronRight {...p} />)({
  color: brand.textDis,
  fontSize: 20,
  flexShrink: 0,
});
